import { forwardRef } from 'react';
import { clsx } from '@team/clsx';
import { ImageBase } from '../../../image-base';
import { BadgeProps } from '../../types';
import css from './style.module.css';

export const Layout = forwardRef<HTMLDivElement, BadgeProps>(function Component(
  { className, ...props },
  forwardedRef
) {
  return (
    <ImageBase.Badge
      {...props}
      className={clsx(className, css.root)}
      ref={forwardedRef}
    />
  );
});
